import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiConnectService} from './api-connect.service';
import {Router} from '@angular/router';
import {AdminService} from './admin.service';
import {StepsControllerService} from './steps-controller.service';
import { StandardVersionSnapshot, standardVersionBody, trackStandardVersion } from './standard-version';

const TEMP_STANDARD_PATH = '/tmp';
const OBSERVE_RESPONSE = 'response';

@Injectable()
export class StepTempControllerService {
  private parrentStandardID = null;
  private tempStandard = null;
  // Использование: поставить false, после успешного сохранения ставить false;
  // А потом публиковать, если нужно;
  private savingProcess = false;
  private editActive = false;
  private editActiveWithNotification = false;

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService,
              private router: Router,
              private adminService: AdminService,
              private stepsControllerService: StepsControllerService) {
  }

  // проверить есть ли временный стандард;
  hasTempStandard() {
    return this.tempStandard !== null;
  }

  setParrentStandardID(psID) {
    this.parrentStandardID = psID;
  }

  getParrentStandardID() {
    return this.parrentStandardID;
  }

  setTempStandard(tempStnd) {
    this.tempStandard = tempStnd;
    this.stepsControllerService.setNotifyType('');
    this.stepsControllerService.activeStep = 8;
    this.stepsControllerService.stepOneDisabled = true;
    this.stepsControllerService.stepTwoDisabled = true;
    this.stepsControllerService.stepThreeDisabled = true;
    this.stepsControllerService.stepFourDisabled = true;
    this.stepsControllerService.stepFiveDisabled = true;
    this.stepsControllerService.stepSixDisabled = true;
    this.stepsControllerService.stepSevenDisabled = true;
    this.stepsControllerService.stepEightDisabled = false;
    this.router.navigate(['/dashboard/create-operating-standard/step-eight']);
  }

  getTempStandard() {
    return this.tempStandard;
  }

  // сохранить;
  saveTempStandard(tempStnd, tmpParrentID, snapshot?: StandardVersionSnapshot) {
    return trackStandardVersion(snapshot, this.http.patch(
      this.apiURL.patchTmpStandard + tmpParrentID + TEMP_STANDARD_PATH,
      standardVersionBody(snapshot, tempStnd), { observe: OBSERVE_RESPONSE }
    ));
  }

  setEditActive(b: boolean) {
    this.editActive = b;
  }

  getEditActive() {
    return this.editActive;
  }

  setEditActiveWithNotification(b: boolean) {
    this.editActiveWithNotification = b;
  }

  getEditActiveWithNotification() {
    return this.editActiveWithNotification;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/step-temp-controller.service.ts